import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { ellipsis } from '@synoptic/ui-kit/utility.css.js';
import { style } from '@vanilla-extract/css';

export const header = style({
  ...typography['titleLg'],
  padding: `0 ${space.s12}px`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  ...responsiveStyle({
    mobile: {
      minHeight: '40px',
    },
    tablet: {
      minHeight: '64px',
    },
  }),
});
export const headerWithBg = style({
  backgroundColor: themeVars.container.primary.background.idle,
  borderRadius: borderRadius.r16,
});

export const headerContent = style({
  flexGrow: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '100%',
});

export const headerSearch = style({
  marginLeft: 'auto',
  paddingLeft: space.s16,
  flex: '1 1 260px',
  maxWidth: '260px',
});

export const headerTitle = style([ellipsis]);
